import { SeasonGroup, Species } from '@omniafishing/core';
import { SeasonGroupIcon } from '../../../season_icon/season_group_icon';
import React from 'react';
import styles from './waterbody_detail_no_reports.less';

interface WaterbodyDetailNoReportsProps {
  selectedSeasonGroup: SeasonGroup;
  selectedSpecies: Species;
}

export const WaterbodyDetailNoReports = (props: WaterbodyDetailNoReportsProps) => {
  const { selectedSeasonGroup, selectedSpecies } = props;

  return (
    <div>
      <div className={styles.noReports}>
        <p>
          <strong>There are No Fishing Reports for</strong>
        </p>
        <div className={styles.filtersContainer}>
          {selectedSpecies && (
            <span className={styles.filterLine}>
              <span>Species</span>
              <span>
                <img src={selectedSpecies.image} alt={selectedSpecies.img_alt} width="50" />
                <span className={styles.speciesName}>{selectedSpecies.display_name}</span>
              </span>
            </span>
          )}
          {selectedSeasonGroup && (
            <span className={styles.filterLine}>
              <span>Season</span>
              <span>
                <SeasonGroupIcon
                  seasonGroupName={selectedSeasonGroup.name}
                  size={21}
                  color={'#fff'}
                  style={{ marginLeft: 5 }}
                />
                {selectedSeasonGroup.display_name}
              </span>
            </span>
          )}
        </div>
        <span>Try different selections to see more results.</span>
      </div>
    </div>
  );
};
